import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["code", "number", "hidden"]

  connect() {
    this.update()
  }

  update() {
    const number = this.numberTarget.value.replace(/\s+/g, "")
    if (number) {
      this.hiddenTarget.value = this.codeTarget.value + number
    } else {
      this.hiddenTarget.value = ""
    }
  }
}
